import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Plus, ShoppingCart, Package, Wallet, Users, Receipt } from "lucide-react";

const ITEMS = [
  { label: "Order", desc: "Buat order baru", icon: ShoppingCart, to: "/orders?new=1", testId: "quick-add-create-order" },
  { label: "Produk", desc: "Tambah produk", icon: Package, to: "/products?new=1", testId: "quick-add-create-product" },
  { label: "Pembayaran", desc: "Catat pembayaran", icon: Wallet, to: "/payments?new=1", testId: "quick-add-create-payment" },
  { label: "Customer", desc: "Tambah pelanggan", icon: Users, to: "/customers?new=1", testId: "quick-add-create-customer" },
  { label: "Pengeluaran", desc: "Tambah pengeluaran", icon: Receipt, to: "/expenses?new=1", testId: "quick-add-create-expense" },
];

export function QuickAddFAB() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid="quick-add-fab" aria-label="Tambah cepat"
          className="fixed z-40 right-4 bottom-4 sm:right-6 sm:bottom-6 h-14 w-14 rounded-full shadow-lg bg-primary text-primary-foreground flex items-center justify-center hover:brightness-105 active:scale-[0.98] transition-[filter,transform] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
          <Plus className={`h-6 w-6 transition-transform duration-200 ${open ? "rotate-45" : ""}`} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="top" sideOffset={12} className="w-64" data-testid="quick-add-menu">
        <DropdownMenuLabel>Tambah cepat</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ITEMS.map((it) => (
          <DropdownMenuItem key={it.label} onSelect={() => navigate(it.to)} data-testid={it.testId} className="gap-3 py-2.5 cursor-pointer">
            <span className="h-8 w-8 rounded-lg bg-secondary flex items-center justify-center shrink-0"><it.icon className="h-4 w-4 text-primary" /></span>
            <span className="flex flex-col">
              <span className="text-sm font-medium">{it.label}</span>
              <span className="text-xs text-muted-foreground">{it.desc}</span>
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
